if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.carrinho = JSON.parse(localStorage.getItem('carrinho')) || [];

        //// Form Product
        this.form = this.querySelector('.form-product');
        this.form.querySelector('[name=id]').disabled = false;
        this.submitButton = this.querySelector('[type="submit"]');

        //// Form Product Motor
        this.formMotor = this.querySelector('.form-motor');

        this.radiosMotor = document.querySelectorAll('[name="drive"]');
        this.arrayOfMotor = Array.from(this.radiosMotor);

        //// Form Product Bando
        this.formBando = this.querySelector('.form-bando');

        this.radiosBando = document.querySelectorAll('[name="bando"]');
        this.arrayOfBando = Array.from(this.radiosBando);

        // Adiciona evento de submit ao form principal se o valor do id for diferente de 0
        if (this.form.querySelector('[name=id]').value !== 0) {
          this.form.addEventListener('submit', this.onSubmitAll.bind(this));
        } else {
          this.setSubmitButtonLabel('Escolha largura e altura');
        }

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
          this.submitButtonMotor?.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      // Faz um loop no conteiner do Comando, vê que opção foi selecionada
      optionMotor() {
        const checkedRadio = this.arrayOfMotor.find((radio) => radio.hasAttribute('data-checked'));
        if (checkedRadio) {
          return checkedRadio.value;
        }
      }

      // Faz um loop no conteiner do Bando, vê que opção foi selecionada
      optionBando() {
        const checkedRadio = this.arrayOfBando.find((radio) => radio.hasAttribute('data-checked'));
        if (checkedRadio) {
          return checkedRadio.value;
        }
      }

      getSubmitButtonLabel(button = this.submitButton) {
        return button?.querySelector('[data-atc-label]') || button?.querySelector('span');
      }

      setSubmitButtonLabel(label, button = this.submitButton) {
        const labelElement = this.getSubmitButtonLabel(button);
        if (labelElement) {
          labelElement.textContent = label;
        }
      }

      preparaFormData(form, cart) {
        const formData = new FormData(form);
        if (cart) {
          formData.append(
            'sections',
            cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement(document.activeElement);
        }
        return formData;
      }

      async enviarProduto(formData, produtoInfo, submitButton = null) {
        if (produtoInfo.type == 'form-product' && submitButton) {
          if (submitButton.getAttribute('aria-disabled') === 'true')
            return Promise.reject(new Error('Botão desabilitado'));

          this.handleErrorMessage();

          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = formData;

        return fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: produtoInfo.type,
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (produtoInfo.type == 'form-product' && submitButton) {
                const soldOutMessage = submitButton.querySelector('.sold-out-message');
                if (!soldOutMessage) return;
                submitButton.setAttribute('aria-disabled', true);
                this.getSubmitButtonLabel(submitButton)?.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
            }
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: produtoInfo.type,
                productVariantId: formData.get('id'),
                cartData: response,
              });
            }
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
            return response;
          })
          .catch((e) => {
            console.error(e);
            throw e;
          })
          .finally(() => {
            if (produtoInfo.type == 'form-product' && submitButton) {
              submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              if (!this.error) submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
          });
      }

      async onSubmitAll(evt) {
        evt.preventDefault();

        try {
          // Prepara e envia o formulário do produto principal
          const formDataPrincipal = this.preparaFormData(this.form, this.cart);
          const idProdutoPrincipal = this.form.querySelector('.product-variant-id').value;
          const produtoPrincipalInfo = { type: 'form-product', id: idProdutoPrincipal };

          const promisePrincipal = this.enviarProduto(formDataPrincipal, produtoPrincipalInfo, this.submitButton);

          await promisePrincipal;

          if (this.optionMotor() === 'Motorizado' && +this.form.querySelector('[name=id]').value !== 0) {
            // Prepara e envia o formulário do motor
            const formDataMotor = this.preparaFormData(this.formMotor, this.cart);
            const idProdutoMotor = this.formMotor.querySelector('.product-motor-id').value;
            const produtoMotorInfo = { type: 'product-form-motor', id: idProdutoMotor };

            const promiseMotor = this.enviarProduto(formDataMotor, produtoMotorInfo);

            await promiseMotor;
          }

          if (this.optionBando() === 'Com bandô' && +this.form.querySelector('[name=id]').value !== 0) {
            // Prepara e envia o formulário do bando
            const formDataBando = this.preparaFormData(this.formBando, this.cart);
            const idProdutoBando = this.formBando.querySelector('.product-bando-id').value;
            const produtoBandoInfo = { type: 'product-form-bando', id: idProdutoBando };

            const promiseBando = this.enviarProduto(formDataBando, produtoBandoInfo);

            await promiseBando;
          }
        } catch (error) {
          console.error('Erro ao enviar produtos:', error);
        }
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        // console.log(errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = 'Largura e Altura incompatíveis.';
        }
      }
    }
  );
}
